<template>

    <div class="home" :style="userid && 'padding: 0' || ''">
        <div v-if="!userid && guide.show" class="guide">
            <div class="guide-item">
                <div class="head">
                    <div class="title">Welcome to CM Offer</div>
                    <div class="content">We're glad to have you here! If you're feeling unsure where to begin, you can get started with these four simple steps.
                    </div>
                </div>
            </div>

            <div class="guide-item">
                <div class="digg">
                    <button class="more" @click="guide.showDigg = !guide.showDigg"><i class="el-icon-more"></i></button>
                    <div v-if="guide.showDigg">
                        <div class="tips">Is this widget helpful to you?</div>
                        <div>
                            <svg :class="`up${guide.digged === 1 && ' active' || ''}${guide.digged > 0 && ' disabled' || ''}`" @click="diggUp" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M889.6 396.8 608 396.8C633.6 262.4 684.8 96 576 44.8 460.8-6.4 454.4 64 441.6 179.2c-12.8 121.6-192 249.6-192 249.6l0 563.2 608 0c83.2-38.4 134.4-377.6 160-499.2C1043.2 371.2 889.6 396.8 889.6 396.8z" p-id="4547" fill="#bfbfbf"></path><path d="M0 428.8l179.2 0 0 569.6-179.2 0 0-569.6Z" p-id="4548" fill="#bfbfbf"></path></svg>
                            <svg :class="`down${guide.digged === 2 && ' active' || ''}${guide.digged > 0 && ' disabled' || ''}`" @click="diggDown" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M889.6 396.8 608 396.8C633.6 262.4 684.8 96 576 44.8 460.8-6.4 454.4 64 441.6 179.2c-12.8 121.6-192 249.6-192 249.6l0 563.2 608 0c83.2-38.4 134.4-377.6 160-499.2C1043.2 371.2 889.6 396.8 889.6 396.8z" p-id="4547" fill="#bfbfbf"></path><path d="M0 428.8l179.2 0 0 569.6-179.2 0 0-569.6Z" p-id="4548" fill="#bfbfbf"></path></svg>
                        </div>
                        
                        <el-divider></el-divider>

                        <a href="#" @click="skipGuide">Skip the guide</a>
                    </div>
                </div>
            </div>

            <div class="guide-item">
                <div class="steps">
                    <div>{{guide.finished}} out of {{guide.steps.length}} steps completed</div>
                    <div class="items">
                        <span v-for="item, idx in guide.steps" :key="idx" :class="`${item.finished && 'active' || ''}`"></span>
                    </div>
                </div>

                <div class="process">
                    <div v-for="item, idx in guide.steps" :key="idx" :class="`item${guide.stepSelected === idx &&' active' || ''}${item.finished && ' finish' || ''}`" @click="guide.stepSelected = idx">{{item.title}}
                        <div class="item-description float-right" v-if="idx === 3 && (guide.countDown[0] > 0 || guide.countDown[1] > 0 || guide.countDown[2] > 0)">
                            <span class="item-description-text">30% off Special offer</span>
                            <span class="item-description-countdown">
                                <span>{{guide.countDown[0] > 9 ? '' : '0'}}{{guide.countDown[0]}}</span>:<span>{{guide.countDown[1] > 9 ? '' : '0'}}{{guide.countDown[1]}}</span>:<span>{{guide.countDown[2] > 9 ? '' : '0'}}{{guide.countDown[2]}}</span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="guide-item">
                <div class="description">
                    <div class="head">
                        <div class="title big">{{guide.stepSelected > -1 && guide.steps[guide.stepSelected].title || ''}}</div>
                        <div class="content">{{guide.stepSelected > -1 && guide.steps[guide.stepSelected].content || ''}}</div>
                    </div>
                    <el-divider></el-divider>

                    <template v-if="guide.finished < guide.steps.length">
                        <div class="head" v-if="guide.stepSelected === 3 && (guide.countDown[0] > 0 || guide.countDown[1] > 0 || guide.countDown[2] > 0)">
                            <div class="title">Exclusive limited-time offer</div>
                            <div class="content">List products for sale before time runs out to get 30% off
    </div>
                            <div class="item-description">
                                <span class="item-description-text">30% off Special offer</span>
                                <span class="item-description-countdown">
                                    <span>{{guide.countDown[0] > 9 ? '' : '0'}}{{guide.countDown[0]}}</span>:<span>{{guide.countDown[1] > 9 ? '' : '0'}}{{guide.countDown[1]}}</span>:<span>{{guide.countDown[2] > 9 ? '' : '0'}}{{guide.countDown[2]}}</span>
                                </span>
                            </div>
                        </div>
                        <template v-if="guide.stepSelected > -1">
                            <a class="guide-button" v-for="btn, btnIdx in guide.steps[guide.stepSelected].buttons" :key="btnIdx" target="_blank" :href="btn.url">{{btn.label}}</a>
                        </template>
                    </template>
                    <div class="completed" v-else>
                        Completed
                    </div>
                </div>
            </div>
        </div>
        <div class="content" v-show="statistics">
            <div class="store-info">
                <div class="store-nickname">
                    <span class="sn-name">{{ userName }}</span>
                    <span class="sn-tag">{{ "Lv" + homeData.rank }}</span>
                    <span class="sn-mainname"
                        >(<i class="el-icon-user-solid"></i>
                        {{ homeData.name }})</span
                    >
                </div>
                <div class="store-domain">
                    <div>
                        <span class="sd-label">Email:</span>
                        <span class="sd-value">{{email || 'loading...'}}</span>
                    </div>
                    <div>
                        <span class="sd-label">Business Code:</span>
                        <span class="sd-value">{{homeData.business_code || 'loading...'}}</span>
                    </div>
                    <div>
                        <span class="sd-label">Registration time:</span>
                        <span class="sd-value">{{registrationTime || 'loading...'}}</span>
                    </div>
                    <div>
                        <span class="sd-label">Last login:</span>
                        <span class="sd-value">{{lastLoginTime || '-'}}</span>
                    </div>
                </div>
                <!-- <div class="divider"></div>
                <div class="my-level_privilege">
                    <div class="my-level">
                        <div class="my-top">
                            <div class="my-top_title">My Address</div>
                        </div>
                        <div class="my-bottom">
                            <el-button size="small" round @click="showAddressList"
                                >Address</el-button
                            >
                        </div>
                    </div>
                    <div class="my-level">
                        <div class="my-top">
                            <div class="my-top_title">My Level</div>
                        </div>
                        <div class="my-bottom">
                            <el-button
                                size="small"
                                round
                                @click="$router.push('/recharge')"
                                >Upgrade</el-button
                            >
                        </div>
                    </div>
                    <div class="my-level">
                        <div class="my-top">
                            <div class="my-top_title">My Coupon</div>
                        </div>
                        <div class="my-bottom">
                            <el-button size="small" round @click="showCouponList"
                                >Coupon</el-button
                            >
                        </div>
                    </div>
                    <div class="my-privilege">
                        <div class="mp-top">
                            <div class="mp-top_title">My Rights</div>
                            <div class="mp-top_icon"></div>
                        </div>
                        <div class="mp-bottom">
                            <span
                                >Download Products / Order Shipment / Inventory
                                Management</span
                            >
                        </div>
                    </div>
                </div> -->
            </div>
            <div class="store-score">
                <div class="title">Products</div>
                <div></div>
                <div></div>
                <div class="title">Orders</div>
                <div></div>
                <div class="border">
                    <p class="sub-title">Wish List</p>
                    <span v-if="!userid" class="pointer" @click="$router.push('/collectionList')">{{homeData.productCount}}</span>
                    <span v-else class="pointer" @click="showtab('wish')">{{homeData.productCount}}</span>
                </div>
                <div class="border">
                    <p class="sub-title">Downloads</p>
                    <span v-if="!userid" class="pointer" @click="$router.push('/downloadList')">{{homeData.downloadCount}}</span>
                    <span v-else class="pointer" @click="showtab('download')">{{homeData.downloadCount}}</span>
                </div>
                <div class="border">
                    <p class="sub-title">Listing <el-tooltip class="item" effect="dark" content="Product summary published in Shopify, Shopline, Shoplazaa and Listing" placement="top"><i class="el-icon-question"></i></el-tooltip></p>
                    <span v-if="!userid" class="pointer" @click="$router.push('/shopifyList')">{{homeData.listingCount}}</span>
                    <span v-else class="pointer" @click="showtab('listing')">{{homeData.listingCount}}</span>
                </div>
                <div class="border">
                    <p class="sub-title">All Orders</p>
                    <span v-if="!userid" class="pointer" @click="$router.push('/ordersList')">{{homeData.orderCount}}</span>
                    <span v-else>{{homeData.orderCount}}</span>
                </div>
                <div class="border">
                    <p class="sub-title">Unpaid</p>
                    <span v-if="!userid" class="pointer" @click="$router.push('/ordersList')">{{homeData.orderUnpaidCount}}</span>
                    <span v-else>{{homeData.orderUnpaidCount}}</span>
                </div>
                <div class="title">Fund</div>
                <div></div>
                <div></div>
                <div class="title">Stores</div>
                <div class="title">Coupons</div>
                <div class="border">
                    <p class="sub-title">Balance($) <el-tooltip class="item" effect="dark" content="Balance = Recharge amount - Expenditure amount" placement="top"><i class="el-icon-question"></i></el-tooltip></p>
                    <span>{{ homeData.balance }}</span><span class="currency">USD</span>
                </div>
                <div class="border">
                    <p class="sub-title">Recharge Amount($) <el-tooltip class="item" effect="dark" content="Accumulated recharge amount" placement="top"><i class="el-icon-question"></i></el-tooltip></p>
                    <span v-if="!userid" class="pointer" @click="$router.push('/rechargeExamine')">{{recharge}}</span><span v-else>{{recharge}}</span><span class="currency">USD</span>
                </div>
                <div class="border">
                    <p class="sub-title">Expenditure Amount($) <el-tooltip class="item" effect="dark" content="Accumulated expenditure amount" placement="top"><i class="el-icon-question"></i></el-tooltip></p>
                    <span v-if="!userid" class="pointer" @click="$router.push('/transactionDetails')">{{consume}}</span><span v-else>{{consume}}</span><span class="currency">USD</span>
                </div>
                <div class="border">
                    <p class="sub-title">Stores</p>
                    <span v-if="!userid" class="pointer" @click="$router.push('/storeList')">{{ homeData.shopCount }}</span>
                    <span v-else class="pointer" @click="showtab('store')">{{ homeData.shopCount }}</span>
                </div>
                <div class="border">
                    <p class="sub-title">Coupons</p>
                    <span v-if="!userid" class="pointer" @click="showCouponList">{{homeData.orderUnpaidCount}}</span>
                    <span v-else>{{homeData.orderUnpaidCount}}</span>
                </div>
            </div>
            <div class="echarts-box">
                <div class="eb-header">
                    <div class="eb-date">
                        <i class="el-icon-date"></i>
                        <span>{{ date[0] }}</span>
                        <span v-show="date[1]"> / {{ date[1] }}</span>
                        <i v-if="!userid" class="el-icon-delete" @click="clearDate"></i>
                    </div>
                    <div class="eb-btns" v-if="!userid">
                        <div
                            class="eb-btns_btn"
                            :class="{ active: filterIndex == item.value }"
                            v-for="(item, i) in filterList"
                            :key="item.value"
                            @click="filterFn(item, i)"
                        >
                            <span>{{ item.label }}</span>
                            <el-date-picker
                                :class="i === 1 && 'home-date-picker' || ''"
                                v-model="date[i]"
                                ref="datePicker"
                                :type="item.value"
                                :value-format="valueFormat[i]"
                                :append-to-body="false"
                                @change="changeDate"
                            >
                            </el-date-picker>
                        </div>
                    </div>
                </div>
                <div class="eb__echarts" id="line"></div>
            </div>
        </div>
        <div class="tabs" v-show="tab_info">
            <span class="goback"  @click="back()"><el-button type="primary" round>back</el-button></span>
            <el-tabs v-model="activeName" type="card" @tab-click="handleClick" style="margin-top: 10px;">
                <el-tab-pane label="Wish List" name="wish">
                    <el-input v-model="keyword" prefix-icon="el-icon-search" placeholder="Keywords include Product Name、SPU、SKU"  @input="search(1)" clearable></el-input>
                    <el-table
                        v-loading="loading"
                        :data="tableData"
                        height="580"
                        style="width: 100%">
                        <el-table-column
                            align="center"
                            width="100"
                            label="image"
                        >
                            <template slot-scope="scope">
                                <el-image
                                    class="elImage_show"
                                    style="height: 80px; width: 80px"
                                    fit="fill"
                                    :src="scope.row.goods.goods_images[0]"
                                    :preview-src-list="scope.row.goods.goods_images"
                                >
                                    <div slot="error" class="image-slot">
                                        <i class="el-icon-picture-outline"></i>
                                    </div>
                                    <div slot="placeholder" class="image-slot">
                                        <i class="el-icon-loading"></i>
                                    </div>
                                </el-image>
                            </template>
                        </el-table-column>
                        <el-table-column
                            property="goods_name"
                            align="left"
                            label="Product Info"
                        >
                            <template slot-scope="scope">
                                <div class="tbItem">
                                    <div
                                        class="goods-name ellipsis-2"
                                    >
                                        {{ scope.row.goods.goods_name }}
                                    </div>
                                    <div>SPU:&nbsp;{{ scope.row.goods.spu }}</div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            align="left"
                            label="Category"
                            prop="goods.goods_category.name_en"
                            width="150"
                        >
                            <template slot-scope="scoped">
                                <div
                                    v-for="item of scoped.row.catalog_names"
                                    :key="item.name"
                                >
                                    {{ item.name_en }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            align="left"
                            label="Created On"
                            prop="created_at"
                            width="150"
                        >
                        </el-table-column>
                        <el-table-column
                            align="left"
                            label="Updated At"
                            prop="last_update_time"
                            width="150"
                        >
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane label="Downloads" name="download">
                    <el-input v-model="keyword" prefix-icon="el-icon-search" placeholder="Keywords include Product Name、SPU、SKU" @input="search(2)" clearable></el-input>
                    <el-table
                        v-loading="loading"
                        :data="tableData"
                        height="580"
                        style="width: 100%">
                        <el-table-column
                            align="center"
                            width="100"
                            :label="$t('downloadList.tableName.goodsImg')"
                        >
                            <template slot-scope="scope">
                                <el-image
                                    class="elImage_show"
                                    style="height: 80px; width: 80px"
                                    fit="fill"
                                    :src="ossImg(scope.row.goods.goods_images[0], 80, 80)"
                                    :preview-src-list="scope.row.goods.goods_images.map(img => ossImg(img, 800, 800))"
                                >
                                    <div slot="error" class="image-slot">
                                        <i class="el-icon-picture-outline"></i>
                                    </div>
                                    <div slot="placeholder" class="image-slot">
                                        <i class="el-icon-loading"></i>
                                    </div>
                                </el-image>
                            </template>
                        </el-table-column>
                        <el-table-column
                            property="goods_name"
                            align="left"
                            :label="$t('downloadList.tableName.goodsInfo')"
                        >
                            <template slot-scope="scope">
                                <div class="tbItem">
                                    <div
                                        class="goods-name ellipsis-2"
                                        @click="toGoodsDetail(scope.row)"
                                    >
                                        {{ scope.row.goods.goods_name }}
                                    </div>
                                    <div>SPU:&nbsp;{{ scope.row.goods.spu }}</div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            align="left"
                            label="Shop"
                            prop="shop_name"
                            width="150"
                        ></el-table-column>
                        <el-table-column
                            align="left"
                            :label="$t('downloadList.tableName.category_name')"
                            prop="goods.goods_category.name_en"
                            width="150"
                        >
                            <template slot-scope="scoped">
                                <div
                                    v-for="item of scoped.row.catalog_names"
                                    :key="item.name"
                                >
                                    {{ item.name_en }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            align="left"
                            :label="$t('downloadList.tableName.download_time')"
                            prop="created_at"
                            width="150"
                        ></el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane label="Listing" name="listing">
                    <div class="listing_cate" >
                        <span class="platform" :class="{'visited':shopifyActive}" @click="setPlatform(1)">Shopify</span>
                        <span class="platform" :class="{'visited':shoplazzaActive}" @click="setPlatform(2)">Shoplazza</span>
                        <span class="platform" :class="{'visited':shoplineActive}" @click="setPlatform(3)">Shopline</span></div>
                    <el-input v-model="keyword" prefix-icon="el-icon-search" placeholder="Keywords include Product Name、SPU、SKU" @input="search(3)" clearable></el-input>
                    <div>
                        <el-table
                        v-loading="loading"
                        :data="tableData"
                        height="540"
                        style="width: 100%">
                            <el-table-column
                                align="center"
                                width="100"
                                label="Image"
                            >
                                <template slot-scope="scope">
                                    <el-image
                                        class="elImage_show"
                                        style="height: 80px; width: 80px"
                                        fit="fill"
                                        :src="scope.row.goods_images[0]"
                                        :previewSrcList="
                                            scope.row.goods_images.length
                                                ? [
                                                    scope.row.goods_images && scope.row.goods_images[0].replace(
                                                        'th_',
                                                        ''
                                                    ),
                                                ]
                                                : ''
                                        "
                                    >
                                        <div slot="error" class="image-slot">
                                            <i class="el-icon-picture-outline"></i>
                                        </div>
                                        <div slot="placeholder" class="image-slot">
                                            <i class="el-icon-loading"></i>
                                        </div>
                                    </el-image>
                                </template>
                            </el-table-column>
                            <el-table-column
                                property="goods_name"
                                align="left"
                                :label="$t('shopifyList.tableName.goodsInfo')"
                                min-width="200"
                            >
                                <template slot-scope="scope">
                                    <div class="tbItem">
                                        <div class="goods-name ellipsis-2">
                                            {{
                                                scope.row.goods_name
                                                    ? scope.row.goods_name
                                                    : "-"
                                            }}
                                        </div>
                                        <div>
                                            Item ID:&nbsp;{{
                                                scope.row.itemID ? scope.row.itemID : "-"
                                            }}
                                        </div>
                                        <div>
                                            SPU:&nbsp;{{
                                                scope.row.spu ? scope.row.spu : "-"
                                            }}
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                align="left"
                                :label="$t('shopifyList.tableName.shop_name')"
                                prop="shop_name"
                                width="150"
                                show-overflow-tooltip
                            >
                            </el-table-column>
                            <el-table-column
                                align="left"
                                :label="$t('shopifyList.tableName.status_cn')"
                                prop="status_cn"
                                width="100"
                            >
                                <template slot-scope="scope">
                                    <span
                                        class="general-table-tag"
                                        :class="[
                                            scope.row.status == 1
                                                ? 'info'
                                                : scope.row.status == 2
                                                ? 'warning'
                                                : 'danger',
                                        ]"
                                    >
                                        <i class="el-icon-s-help"></i>
                                        {{ scope.row.status_cn }}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                align="left"
                                :label="$t('shopifyList.tableName.category_name')"
                                prop="category_name"
                                width="150"
                                show-overflow-tooltip
                                v-show="category_show"
                            >
                            </el-table-column>
                            <el-table-column
                                align="left"
                                :label="$t('shopifyList.tableName.create_time')"
                                prop="created_at"
                                width="150"
                            >
                            </el-table-column>
                        </el-table>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="Store" name="store">
                    <el-input v-model="keyword" prefix-icon="el-icon-search" placeholder="Keywords include Shop Name" @input="search(4)" clearable></el-input>
                    <el-table
                        v-loading="loading"
                        :data="tableData"
                        height="580"
                        style="width: 100%">
                        <el-table-column
                            width="60"
                            align="left"
                            label="ID"
                            prop="id"
                        ></el-table-column>
                        <el-table-column
                            label="Name"
                            property="name"
                            align="left"
                            min-width="230"
                        >
                            <template slot-scope="scope">
                                <div class="tableTitleCont">
                                    <div class="topTitle">
                                        <a
                                            :href="
                                                scope.row.http_type + scope.row.shop_url
                                            "
                                            v-if="
                                                scope.row.http_type &&
                                                scope.row.shop_url
                                            "
                                            target="_blank"
                                            >{{ scope.row.name }}</a
                                        >
                                        <p v-else>
                                            <span>{{ scope.row.name }}</span>
                                            <span
                                                class="row_username"
                                                v-if="scope.row.user_name"
                                                >({{ scope.row.user_name }})</span
                                            >
                                        </p>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            :label="$t('storeList.tableName.platform_id')"
                            property="platform_name"
                            align="left"
                            width="100"
                        ></el-table-column>
                        <el-table-column
                            label="Sync Order"
                            align="left"
                            width="100"
                        >
                            <template slot-scope="scoped">
                                <i
                                    class="col-customized"
                                    :class="[
                                        scoped.row.sync_order == 1
                                            ? 'el-icon-circle-check check'
                                            : 'el-icon-circle-close',
                                    ]"
                                ></i>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="App Type"
                            property="auth_type"
                            align="left"
                            width="100"
                        >
                            <template slot-scope="scoped">
                                <span v-if="scoped.row.auth_type == 1">Private</span>
                                <span v-else-if="scoped.row.auth_type == 2">Custom</span>
                                <span v-else>App</span>
                            </template>
                        </el-table-column>

                        <el-table-column
                            label="Store Url"
                            property="shop_url"
                            align="left"
                            width="75"
                        >
                            <template slot-scope="scoped">
                                <a :href="scoped.row.shop_url" target="_blank" v-if="scoped.row.shop_url" >
                                    <i class="col-customized el-icon-link check"></i>
                                </a>
                            </template>
                        </el-table-column>
                        
                        <el-table-column
                            label="Customized Field"
                            property="customized"
                            align="center"
                        >
                            <template slot-scope="scoped">
                                <i
                                    class="col-customized"
                                    :class="[
                                        scoped.row.customized == 1
                                            ? 'el-icon-circle-check check'
                                            : 'el-icon-circle-close',
                                    ]"
                                ></i>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="Authorized"
                            align="center"
                            min-width="90"
                        >
                            <template slot-scope="scope">
                                <span
                                    class="general-table-tag"
                                    :class="[
                                        scope.row.authed == 1 ? 'success' : 'info',
                                    ]"
                                >
                                    <i class="el-icon-s-help"></i>
                                    {{
                                        scope.row.authed == 1
                                            ? $t("storeList.tableName.authed_success")
                                            : $t("storeList.tableName.authed_danger")
                                    }}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            :label="$t('storeList.tableName.create_at')"
                            property="created_at"
                            align="center"
                            width="140"
                        ></el-table-column>
                    </el-table>
                </el-tab-pane>
            </el-tabs>
            <pagination
                :paginationData="paginationData"
                @paginationChange="paginationChange"
                :funcName="funcName"
            ></pagination>
        </div>
        <add :addVisible.sync="addVisible"></add>
        <edit :editVisible.sync="editVisible" :tableItem="tableItem"></edit>
        <addressList
            :isShowUse="false"
            :listVisible.sync="listVisible"
            @replaceAddress="replaceAddress"
            @editAddress="editAddress"
        ></addressList>
        <myCoupon :couponListVisible.sync="couponListVisible"></myCoupon>
        <couponDialog :couponDialogVisible.sync="couponDialogVisible"></couponDialog>
        <el-dialog
            title="Tips"
            :visible.sync="authTipShow"
            append-to-body
            class="auth-tip"
            :before-close="() => {authTipShow = false; $router.replace('/home')}"
            width="30%">
            <div class="auth-tip-body">
                <el-alert
                    title="Congratulations, your store has been created successfully, please configure the store to use."
                    type="success"
                    :closable="false">
                </el-alert>
                <div class="auth-tip-body-store">
                    <img v-if="authPlatform && ['shopify', 'shoplazza', 'shopline'].includes(authPlatform)" :src="require(`@/assets/image/goods/${authPlatform}.png`)"/>
                    {{authStore}}
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="() => {authTipShow = false; $router.replace('/storeList')}">Configure Store</el-button>
                <el-button @click="() => {authTipShow = false; $router.replace('/home')}">Close</el-button>
            </span>
        </el-dialog>
    </div>

</template>
<script>
import * as echarts from "echarts";
import { cmofferApi } from "@/http/cmofferApi.js";
import { infoTagsMixins } from "@/utils/infoTagsMixins.js";
import { tableMixins } from "@/utils/tableMixins.js";
import textScroll from "@/common/components/textScroll";
import myCoupon from "@/common/components/myCoupon";
import couponDialog from "@/common/components/couponDialog";
import add from "./shipping/shippingAdmin/add.vue";
import edit from "./shipping/shippingAdmin/edit.vue";
import addressList from "./shipping/shippingAdmin/addressList.vue";
import { Notification } from 'element-ui';

export default {
    name: "Home",
    mixins: [infoTagsMixins, tableMixins],
    data() {
        return {
            statistics: true,
            tab_info: false,
            searchForm: "",
            activeName: 'wish',
            keyword: "",
            funcName: "",
            shopifyActive: true,
            shoplazzaActive: false,
            shoplineActive: false,
            category_show: true,
            userName: localStorage.getItem("last_name"),
            email: '',
            businessCode: '',
            registrationTime: '',
            lastLoginTime: '',
            newGoodsList: [],
            addVisible: false,
            editVisible: false,
            listVisible: false,
            couponListVisible: false,
            couponDialogVisible: false,
            consume: 0,
            recharge: 0,
            filterIndex: "Day",
            filterList: [
                {
                    label: "Year",
                    value: "year",
                },
                {
                    label: "Month",
                    value: "month",
                },
            ],
            homeData: {},
            date: ["", ""],
            valueFormat: ["yyyy", "MM"],
            authPlatform: "",
            authStore: '',
            authTipShow: false,
            guide: {
                show: false,
                digged: 0,
                steps: [
                    {
                        title: 'Choose your first product',
                        content: 'Have a look through our catalogue of 10,000+ best-selling products and add your favorites to a wish list for your store. We recommend choosing between 8 to 12 products to get your business started.',
                        buttons: [
                            {
                                label: 'Go to tutorial',
                                url: 'https://www.cmoffer.com/how-to-choose-products',
                            }
                        ],
                        finished: false,
                    },
                    {
                        title: 'Order a sample',
                        content: 'Purchasing a physical sample will help you to build confidence in your new fulfillment capabilities, and the quality of your products. It can also be helpful for taking lifestyle photos that can increase the conversion rate of your product listing page.',
                        buttons: [
                            {
                                label: 'Go to tutorial',
                                url: 'https://www.cmoffer.com/how-to-order-a-sample',
                            }
                        ],
                        finished: false,
                    },
                    {
                        title: 'Connect your store',
                        content: 'Keep important order data easy to access by connecting a store to your CM Offer account. It only takes a couple minutes, and you\'ll thank yourself later when you are ready to open your second ecommerce store!',
                        buttons: [
                            {
                                label: 'Etsy Tutorial',
                                url: 'https://www.cmoffer.com/how-to-connect-an-etsy-shop',
                            },
                            {
                                label: 'Shopify Tutorial',
                                url: 'https://www.cmoffer.com/how-to-connect-a-shopify-store',
                            },
                        ],
                        finished: false,
                    },
                    {
                        title: 'List products for sale',
                        content: 'Import your wish list products to your ecommerce partner store and get selling to real customers! Prepare to spend around 1 hour per product listing, we recommend having 8 to 12 products listed for your store launch.',
                        buttons: [
                            {
                                label: 'Etsy Tutorial',
                                url: 'https://www.cmoffer.com/how-to-import-a-product-to-etsy',
                            },
                            {
                                label: 'Shopify Tutorial',
                                url: 'https://www.cmoffer.com/how-to-import-a-product-to-shopify',
                            },
                        ],
                        finished: false,
                    },
                ],
                stepSelected: -1,
                finished: -1,
                countDown: [0, 0, 0],
                countDownInterval: null,
                showDigg: false,
            },
            warned: false,
            paginationData: {
                page: 1,
                "per-page": 20,
                total: "",
            },
            tableData: [],
            loading: false,
        };
    },
    components: {
        add,
        edit,
        addressList,
        textScroll,
        myCoupon,
        couponDialog,
    },
    methods: {
        routeTo(url, params_) {
            if (!params_) {
                this.$router.push(url);
            } else if (params_) {
                this.$router.push({
                    name: url,
                    params: {
                        ...params_,
                    },
                });
            }
        },
        handleClick(tab) {
            this.keyword = "";
            if(tab.name == "wish"){
                this.collectionList(1);
                this.funcName = "collectionList";
            }else if(tab.name == "download"){
                this.downloadList(1);
                this.funcName = "downloadList";
            }else if(tab.name == "store"){
                this.storeList(1);
                this.funcName = "storeList";
            }else if(tab.name == "listing"){
                this.shopifyList(1);
                this.funcName = "shopifyList";
                this.category_show = true;
            } 
        },
        showtab(name){
            this.statistics = false;
            this.tab_info = true;
            this.activeName = name 
            this.keyword = "";
            if(name == "listing"){
                this.setPlatform(1)
            }
        },
        search(m){
            if(m == 1){
                this.collectionList(1);
            }else if(m == 2){
                this.downloadList(1);
            }else if(m == 3){
                if(this.shopifyActive){
                    this.shopifyList(1);
                }else if(this.shoplazzaActive){
                    this.shoplazzaList(1);
                }else if(this.shoplineActive){
                    this.shoplineList(1);
                }
            }else if(m == 4){
                this.storeList(1);
            }
        },
        setPlatform(v){
            if(v == 1){
                this.shopifyActive = true;
                this.shoplazzaActive = false;
                this.shoplineActive = false;
                this.shopifyList(1);
                this.funcName = "shopifyList";
                this.category_show = true;
            }else if(v == 2){
                this.shopifyActive = false;
                this.shoplazzaActive = true;
                this.shoplineActive = false;
                this.shoplazzaList(1);
                this.funcName = "shoplazzaList";
                this.category_show = false;
            }else if(v == 3){
                this.shopifyActive = false;
                this.shoplazzaActive = false;
                this.shoplineActive = true;
                this.shoplineList(1);
                this.funcName = "shoplineList";
                this.category_show = false;
            }
        },
        filterFn(item, i) {
            // console.log("item: ", item);
            this.filterIndex = item.value;
            this.$refs.datePicker[i].handleFocus();
        },
        orderWarning() {
            if (!this.warned) {
                this.warned = true;

                this.$notify({
                    title: 'WARNING',
                    message: 'Please note that products ordered from your store will not be fulfilled until you finished the payment process.',
                    duration: 0
                });
            }
        },
        getHomeData() {
            cmofferApi.homeData({userid: this.userid}, "get").then((res) => {
                if (res) {
                    // console.log("res: ", res);
                    this.homeData = res.data.entity;
                    const {
                        listingCount,
                        downloadCount,
                        orderCount,
                        orderUnpaidCount,
                        productCount,
                        couponCount,
                        shopCount,
                        user,
                        consume,
                        recharge
                    } = res.data;
                    this.homeData.listingCount = listingCount;
                    this.homeData.orderCount = orderCount;
                    this.homeData.orderUnpaidCount = orderUnpaidCount;
                    this.homeData.productCount = productCount;
                    this.homeData.downloadCount = downloadCount;
                    this.homeData.shopCount = shopCount;
                    this.homeData.couponCount = couponCount;
                    this.consume = consume || 0;
                    this.recharge = recharge || 0;

                    const { login_count, coupon, skip_guide, is_helpful, is_first_product, is_order_sample, is_connect_store, is_list_product, email, created_at, last_login_time, username } = user

                    if (login_count == 1 && coupon.is_notify === 2) {
                        this.couponDialogVisible = true;
                    }
                    if(!this.userid && res.data.notProcessed > 0){
                        this.orderWarning();
                    }

                    this.guide.show = !skip_guide;
                    this.guide.digged = is_helpful;
                    let stepSelectedSetted = false;
                    if (is_first_product === 1) {
                        this.guide.steps[0].finished = true;
                    } else {
                        stepSelectedSetted = true;
                        this.guide.stepSelected = 0;
                    }

                    if (is_order_sample === 1) {
                        this.guide.steps[1].finished = true;
                    } else if (!stepSelectedSetted) {
                        stepSelectedSetted = true;
                        this.guide.stepSelected = 1;
                    }

                    if (is_connect_store === 1) {
                        this.guide.steps[2].finished = true;
                    } else if (!stepSelectedSetted) {
                        stepSelectedSetted = true;
                        this.guide.stepSelected = 2;
                    }

                    if (is_list_product === 1) {
                        this.guide.steps[3].finished = true;
                    } else if (!stepSelectedSetted) {
                        stepSelectedSetted = true;
                        this.guide.stepSelected = 3;
                    }

                    if (!stepSelectedSetted) {
                        this.guide.stepSelected = 0;
                    }

                    this.guide.countDownInterval = setInterval(() => {
                        this.countDown(created_at);
                    }, 1000);

                    this.guide.finished = is_first_product + is_connect_store + is_list_product + is_order_sample;

                    this.email = email;
                    this.registrationTime = created_at;
                    this.lastLoginTime = last_login_time;

                    this.userName = username || email.split('@')[0];
                }
            });
        },
        add() {
            this.addVisible = true;
        },
        showAddressList() {
            this.listVisible = true;
        },
        showCouponList() {
            this.couponListVisible = true;
        },
        editAddress(row) {
            this.editVisible = true;
            this.tableItem = row;
        },
        replaceAddress(row) {
            this.address = row;
        },
        toCollectionList() {
            this.$router.push({
                path: "/collectionList",
            });
        },
        async initialize() {
            // 已登录，绑定店铺
            const authTip = sessionStorage.getItem('authTip');
            const token_ptk = this.$route.query._ptk_;
            if (authTip) {
                const [platform, store] = authTip.split('-');
                this.showAuthTip(platform, store);
                sessionStorage.removeItem('authTip');

                if (token_ptk) {
                    this.$router.replace('/home');
                }
            } else if (token_ptk) {
                cmofferApi.bindStore({}, 'post', '', {
                    headers: {
                        'Platform-Token': token_ptk
                    }
                }).then(res => {
                    if (res && res.errcode === 0) {
                        this.showAuthTip(res.platform, res.store);
                    }
                });

                this.$router.replace('/home');
            }
        },
        orderAnalysis() {
            cmofferApi
                .orderAnalysis(
                    {
                        userid: this.userid,
                        year: this.date[0],
                        month: this.date[1],
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        // console.log(res);
                        let { data } = res;
                        this.lineOption.xAxis.data = [];
                        this.lineOption.series[0].data = [];
                        data.forEach((item) => {
                            this.lineOption.xAxis.data.push(item.node);
                            this.lineOption.series[0].data.push(
                                item.order_count
                            );
                        });
                        var myChart = echarts.init(
                            document.getElementById("line")
                        );
                        myChart.setOption(this.lineOption);
                    }
                });
        },
        changeDate(val) {
            this.orderAnalysis();
        },
        clearDate() {
            this.date = ["", ""];
            this.date[0] = new Date().getFullYear().toString();
            this.orderAnalysis();
        },
        showAuthTip(platform, store) {
            this.authPlatform = platform;
            this.authStore = store;
            this.authTipShow = true;
        },
        countDown(date) {
            // 注册加1天
            const endTime = (new Date(date).getTime()) + 86400000;
            const currentTime = new Date().getTime();

            let hours = 0;
            let minutes = 0;
            let seconds = 0;

            let diff = endTime - currentTime;

            if (diff < 1000) {
                clearInterval(this.guide.countDownInterval);
                this.guide.countDown = [hours, minutes, seconds];
                return;
            }

            diff /= 1000;

            hours = Math.floor(diff / 3600);
            minutes = Math.floor(diff % 3600 / 60);
            seconds = Math.floor(diff % 60);

            this.guide.countDown = [hours, minutes, seconds];
        },
        diggUp() {
            if (this.guide.digged > 0) return
            cmofferApi.diggGuide({
                helpful: 1
            }, 'post', '').then(res => {
                if (res && res.errcode === 0) {
                    this.guide.digged = 1;
                }
            }); 
        },
        diggDown() {
            if (this.guide.digged > 0) return
            cmofferApi.diggGuide({
                helpful: 2
            }, 'post', '').then(res => {
                if (res && res.errcode === 0) {
                    this.guide.digged = 2;
                }
            }); 
        },
        skipGuide(evt) {
            evt.preventDefault();
            cmofferApi.skipGuide({}, 'post', '').then(res => {
                if (res && res.errcode === 0) {
                    this.guide.show = false;
                }
            }); 
        },
        back(){
            this.statistics = true;
            this.tab_info = false;
        },
        collectionList(page) {
            this.lists(page,"collectionList");
        },
        // 获取下载列表
        downloadList(page) {
            this.lists(page,"downloadList");
        },
        //获取商店table
        storeList(page) {
            this.lists(page,"shop");
        },
        shopifyList(page) {
            this.lists(page,"shopifyListing");
        },
        shoplazzaList(page){
            this.lists(page,"shoplazzaListing");
        },
        shoplineList(page){
            this.lists(page,"shoplineListing");
        },
        lists(page,func){
            this.loading = true;
            page ? (this.paginationData.page = 1) : "";
            cmofferApi[func](
                {
                    ...this.paginationData,
                    keyword: this.keyword,
                    user_id:this.userid,
                    refer: "home"
                },
                "get"
            )
            .then((res) => {
                if (res) {
                    this.tableData = res.data;
                    this.paginationData.total = res.total;
                    this.loading = false;
                }
            })
            .catch(() => {
                this.loading = false;
            });
        },
    },
    computed: {
        lineOption() {
            let white = "#ffffff";
            let gray = "#aaaaaa";
            return {
                tooltip: {
                    trigger: "axis",
                },
                legend: {
                    data: ["同行平均", "同行优秀", "Orders"],
                    textStyle: {
                        fontSize: 12,
                        color: gray,
                    },
                },
                grid: {
                    left: "3%",
                    right: "4%",
                    bottom: "3%",
                    containLabel: true,
                },
                xAxis: {
                    type: "category",
                    boundaryGap: true,
                    data: [
                        /* "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun" */
                    ],
                    axisLine: {
                        lineStyle: {
                            color: gray,
                        },
                    },
                    axisTick: {
                        lineStyle: {
                            color: gray,
                        },
                        alignWithLabel: true,
                    },
                    axisLabel: {
                        color: gray,
                    },
                },
                yAxis: {
                    type: "value",
                    axisLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                    splitLine: {
                        lineStyle: {
                            color: "#efefef",
                            type: "dashed",
                        },
                    },
                },
                series: [
                    /* {
                        name: "同行优秀",
                        type: "line",
                        stack: "Total",
                        smooth: true,
                        data: [120, 132, 101, 134, 90, 230, 210],
                        symbol: "circle",
                        symbolSize: 7,
                        itemStyle: {
                            borderWidth: 1,
                            borderColor: white,
                            color: "#2fc25b",
                        },
                    },
                    {
                        name: "同行平均",
                        type: "line",
                        stack: "Total",
                        smooth: true,
                        data: [220, 182, 191, 234, 290, 330, 310],
                        symbol: "circle",
                        symbolSize: 7,
                        itemStyle: {
                            borderWidth: 1,
                            borderColor: white,
                            color: "#facc14",
                        },
                    }, */
                    {
                        name: "Orders",
                        type: "line",
                        stack: "Total",
                        smooth: true,
                        data: [150, 232, 201, 154, 190, 330, 410],
                        symbol: "circle",
                        symbolSize: 7,
                        itemStyle: {
                            borderWidth: 1,
                            borderColor: white,
                            color: "#635cff",
                        },
                    },
                ],
            };
        },
    },
    props: {
        userid: Number
    },
    created() {
        this.initialize();
    },
    mounted() {
        
        var myChart = echarts.init(document.getElementById("line"));
        window.onresize = function () {
            myChart.resize();
        };
    },
    activated() {
        if (this.userid) return

        const url = new URL(location.href)
        const ref = url.searchParams.get('ref')
        if (ref && ref.includes('/goodsList')) {
            this.$notify({
                title: 'Tips',
                dangerouslyUseHTMLString: true,
                message: '<span style="color:#635cff;cursor:pointer">Click here to continue to browse the previous product.</span>',
                duration: 0,
                onClick: () => {
                    Notification.closeAll()
                    this.$router.push('/goodsList' + ref.split('/goodsList')[1])
                }
            });
        }

        this.getHomeData();

        this.date[0] = new Date().getFullYear().toString();
        this.orderAnalysis();
    },
    destroyed() {
        clearInterval(this.guide.countDownInterval)
    },
    watch: {
        userid: {
            handler(v) {
                if (v) {
                    this.statistics = true;
                    this.tab_info = false;
                    this.getHomeData();
                    this.date[0] = new Date().getFullYear().toString();
                    this.orderAnalysis();
                }
            },
            immediate: true,
            deep: true
        },
        tab_info:{
            handler(v) {
                if (v) {
                    if(this.activeName == "wish"){
                        this.collectionList(1);
                        this.funcName = "collectionList";
                    }else if(this.activeName == "download"){
                        this.downloadList(1);
                        this.funcName = "downloadList";
                    }else if(this.activeName == "store"){
                        this.storeList(1);
                        this.funcName = "storeList";
                    }else if(this.activeName == "listing"){
                        this.shopifyList(1);
                        this.funcName = "shopifyList";
                    }
                }
            },
            immediate: true,
            deep: true
        }
    }
};
</script>
<style lang="scss">
.home {
    min-height: 100%;
    width: 100%;
    padding: 15px 30px;
    box-sizing: border-box;
    text-align: left;

    .guide {
        line-height: 170%;
        display: grid;
        grid-column: 2;
        column-gap: 8%;
        grid-template-columns: 46% auto;
        margin-bottom: 30px;
        color: #222222;

        .float-right {
            float: right;
        }

        &-item {
            position: relative;
            padding: 20px;
            // padding-right: 50px;

            // +.el-col {
            //     padding-right: 20px;
            //     padding-left: 50px;
            // }

            .head {
                .title {
                    font-size: 16px;
                    font-weight: bold;

                    &.big {
                        font-size: 18px;
                        line-height: 200%;
                    }
                }
                .content {
                    font-size: 14px;
                }

                // &:first-child {
                //     padding-bottom: 30px;
                // }
            }

            .steps {
                font-size: 14px;

                .items {
                    display: grid;
                    column-gap: 5px;
                    grid-auto-flow: column;
                    span {
                        display: block;
                        background-color: #f2f2f2;
                        height: 5px;

                        &.active {
                            background-color: #23bcb5;
                        }
                    }
                }
            }

            .process {
                margin-top: 25px;

                .item {
                    color: #000000;
                    font-weight: bold;
                    font-size: 16px;
                    line-height: 40px;
                    height: 40px;
                    vertical-align: middle;
                    border-radius: 5px;
                    cursor: pointer;
                    user-select: none;
                    border: 1px solid #e5e5e5;
                    box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
                    transition: border .2s linear,box-shadow .2s linear;

                    &.active {
                        background-color: #f2f2f2;
                    }

                    &::before {
                        content: "1";
                        font-size: 16px;
                        font-weight: normal;
                        background-color: #f2f2f2;
                        color: #808080;
                        border-radius: 50%;
                        width: 24px;
                        height: 24px;
                        display: inline-block;
                        text-align: center;
                        line-height: 24px;
                        margin-right: 15px;
                        margin-left: 10px;
                    }

                    &.finish {
                        color: #b1b1b1;
                        &::before {
                            content: "L"!important;
                            color: #ffffff;
                            background-color: #23bcb5;
                            transform: rotate(45deg) scaleX(-1);
                        }
                    }

                    &+.item {
                        margin-top: 10px;

                        &::before {
                            content: "2";
                        }

                        &+.item {
                            &::before {
                                content: "3";
                            }

                            &+.item {
                                &::before {
                                    content: "4";
                                }
                            }
                        }
                    }

                   
                }
            }

            .item-description {
                margin-right: 10px;

                &-text {
                    background-color: #e20c16;
                    color: #ffffff;
                    margin-right: 20px;
                    padding: 2px 10px;
                    border-radius: 4px;
                }

                &-countdown {
                    span {
                        display: inline-block;
                        border: 1px solid #dadada;
                        padding: 5px;
                        line-height: 16px;
                        margin-left: 4px;
                        margin-right: 4px;
                        border-radius: 4px;

                        &:first-child {
                            margin-left: 0;
                        }
                        &:last-child {
                            margin-right: 0;
                        }
                    }
                }
            }

            .description {
                .el-divider {
                    &+.head {
                        .item-description {
                            margin-top: 10px;
                        }

                        margin-bottom: 30px;
                    }
                }
                .guide-button {
                    border: 1px solid transparent;
                    border-radius: 5px;
                    box-sizing: border-box;
                    cursor: pointer;
                    display: inline-block;
                    font-size: 16px;
                    font-weight: 700;
                    height: 40px;
                    letter-spacing: 0;
                    line-height: 38px;
                    min-width: 88px;
                    outline: 0;
                    padding-left: 24px;
                    padding-right: 24px;
                    text-align: center;
                    text-decoration: none;
                    user-select: none;
                    white-space: nowrap;
                    background-color: #e5e5e5;
                    color: #222;

                    &+.guide-button {
                        margin-left: 20px;
                    }

                    &:hover {
                        border-color: #b1b1b1;
                        box-shadow: 0 2px 4px 0 rgb(0 0 0 / 25%);
                    }

                    &:active {
                        border-color: #b1b1b1;
                        box-shadow: inset 0 2px 5px 0 rgb(0 0 0 / 50%);
                    }
                }

                .completed {
                    &::before {
                        font-size: 28px;
                        font-weight: bold;
                        margin-right: 10px;
                        margin-left: 10px;
                        display: inline-block;
                        content: "L"!important;
                        color: #23bcb5;
                        transform: rotate(45deg) scaleX(-1);
                    }
                }
            }

            .digg {
                >div {
                    text-align: center;
                    width: 300px;
                    display: inline-block;
                    position: absolute;
                    top: 20px;
                    right: 50px;
                    z-index: 1;
                }

                .more {
                    position: absolute;
                    top: 20px;
                    right: 20px;
                    transform: rotate(90deg);
                    background-color: transparent;
                    border: unset;
                    font-size: 20px;
                }

                .tips {
                    margin-bottom: 10px;
                }

                .up, .down {
                    width: 36px;
                    height: 36px;
                    cursor: pointer;
                    display: inline-block;

                    &:hover, &.active {
                        path {
                            fill: #635cff;
                        }
                    }

                    &.disabled {
                        cursor: default!important;

                        &:hover:not(.active) {
                            path {
                                fill: #bfbfbf;
                            }
                        }
                    }
                }

                .down {
                    margin-left: 20px;
                    transform: rotate(180deg);
                }

                .el-divider {
                    margin-top: 10px;
                    margin-bottom: 10px;
                }

                a {
                    color: #2a76b3;
                    text-decoration: none;
                    cursor: pointer;
                }
            }
        }
    }

    .store-info {
        padding: 20px;
        box-sizing: border-box;
        width: 100%;
        // min-height: 200px;
        background-color: #e3eaf6;
        .store-nickname {
            margin-bottom: 30px;
            .sn-name {
                font-size: 16px;
                margin-right: 8px;
                font-weight: bold;
            }
            .sn-tag {
                color: #ffffff;
                padding: 2px 6px;
                border-radius: 9999px;
                background: #273478;
                font-size: 12px;
            }
            .sn-mainname {
                font-size: 14px;
                color: $color-font-description;
                margin: 0 0 0 10px;
            }
        }
        .store-domain {
            display: flex;
            justify-content: space-between;
            font-size: 14px;
            color: $color-808080;

            .sd-value {
                margin: 0 4px 0 15px;
                // font-weight: bold;
            }
        }
        .divider {
            width: 80%;
            height: 1px;
            background: #ffffff;
            margin: 25px 0 35px;
        }
        .my-level_privilege {
            display: flex;
            .my-level {
                margin-right: 40px;
                .my-top {
                    display: flex;
                    align-items: center;
                    margin-bottom: 10px;
                    .my-top_title {
                        font-size: 16px;
                        margin-right: 10px;
                    }
                    .my-top_subtitle {
                        font-size: 13px;
                        color: #86c5e4;
                    }
                }
                .my-bottom {
                    .el-button {
                        padding-left: 20px;
                        padding-right: 20px;
                        color: #5c6393;
                        background: #f4f9fd;
                    }
                }
            }
            .my-privilege {
                font-size: 13px;
                .mp-top {
                    display: flex;
                    align-items: center;
                    margin-bottom: 14px;
                    .mp-top_title {
                        font-size: 16px;
                        margin-right: 10px;
                    }
                    .mp-top_icon {
                    }
                }
                .mp-bottom {
                    span + span {
                        margin-left: 20px;
                    }
                }
            }
        }
    }
    .store-score {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
        margin-top: 10px;
        padding: 10px;
        box-sizing: border-box;
        width: 100%;
        min-height: 150px;
        background-color: #f4f9fd;
        // color: $color-808080;

        > div {
            padding: 12px 12px 16px 12px;
        }

        .title {
            font-weight: bold;
        }

        .border {
            border: 1px solid #ededed;
            margin-bottom: 10px;
            .sub-title {
                font-size: 14px;
                color: $color-808080;
                margin-bottom: 16px;
                margin-top: 5px;
            }

            .pointer {
                cursor: pointer;
                &:hover {
                    text-decoration: underline;
                }
            }

            .currency {
                margin-left: 4px;
                display: inline-block;
                font-size: 12px;
                color: $color-808080;
            }

            &+.border {
                border-left: 0;
            }
        }

        .ss-title {
            font-size: 16px;
            margin-bottom: 25px;
        }
        .score-grids {
            display: grid;
            grid-template-columns: repeat(4, 20%);
            grid-column-gap: 10px;
            grid-template-rows: 1;
            .score-grid {
                font-size: 13px;
                .sg-label {
                    margin: 0 4px 10px 0;
                    i {
                        margin: 0 0 0 4px;
                    }
                }
                .sg-value {
                    font-size: 24px;
                    span {
                        font-size: 14px;
                    }
                }
            }
        }
    }
    // .data-grids {
    //     display: grid;
    //     grid-template-columns: repeat(4, 1fr);
    //     margin-top: 30px;
    //     max-width: 75%;
    //     .data-grid {
    //         // height: 130px;
    //         border: 1px solid #f0f0f1;
    //         background: #f8f9fc;
    //         box-sizing: border-box;
    //         padding: 12px;
    //         .dg-label {
    //             font-size: 13px;
    //             i {
    //                 color: $color-primary-blue;
    //                 font-weight: bold;
    //                 margin-left: 4px;
    //             }
    //         }
    //         .dg-value {
    //             margin: 8px 0 13px;
    //             font-size: 24px;
    //             cursor: pointer;
    //             &:hover {
    //                 text-decoration: underline;
    //             }
    //         }
    //         .dg-comparison {
    //             display: flex;
    //             justify-content: space-between;
    //             .dg-comparison_left,
    //             .dg__c__right {
    //                 width: 49%;
    //                 font-size: 12px;
    //                 .dg-comparison_left__value {
    //                     font-size: 14px;
    //                     margin-bottom: 10px;
    //                 }
    //                 .dg-comparison_left__label {
    //                     color: $color-808080;
    //                 }
    //             }
    //         }
    //         & + .data-grid {
    //             border-left: none;
    //         }
    //         &.active {
    //             border-bottom-color: #ffffff;
    //             background: #ffffff;
    //         }
    //     }
    // }
    .text-24 {
        font-size: 24px;
    }
    .echarts-box {
        // max-width: 75%;
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        font-size: 12px;
        .eb-header {
            display: flex;
            justify-content: flex-start;
            padding-left: 20px;
            // width: 100%;
            align-items: center;
            .eb-date {
                margin-right: 20px;
                font-size: 13px;
                .el-icon-date {
                    margin-right: 5px;
                }
                .el-icon-delete {
                    margin-left: 5px;
                    &:active {
                        color: $color-primary;
                    }
                }
            }
            .eb-btns {
                display: flex;
                align-self: flex-end;
                border: 1px solid #e5e5e5;
                .eb-btns_btn {
                    position: relative;
                    padding: 8px 12px;
                    box-sizing: border-box;
                    background: #f5f6fa;
                    user-select: none;
                    cursor: pointer;
                    height: 28px;
                    &.active {
                        background: #ffffff;
                    }
                    & + .eb-btns_btn {
                        border-left: 1px solid #e5e5e5;
                    }
                    .el-date-editor {
                        .el-input__inner, .el-input__prefix, .el-input__suffix {
                            display: none;
                        }
                    }

                    .el-year-table {
                        td {
                            &.current {
                                .cell {
                                    font-weight: 700;
                                }
                            }
                            &.today:not(.current) {
                                .cell {
                                    color: #606266;
                                    font-weight: normal;
                                }
                            }
                        }
                    }

                    .home-date-picker {
                        .el-date-picker__header {
                            display: none;
                        }
                    }
                }
            }
        }
        .eb__echarts {
            margin: 30px 0 50px;
            width: 100%;
            height: 500px;
        }
    }

    .noticeBox {
        width: 100%;
        height: 30px;
        line-height: 30px;
        overflow: hidden;
        position: relative;
        margin-bottom: 12px;
    }
    .cardCont {
        width: 100%;
        box-sizing: border-box;
        display: flex;
        .cardCont_item {
            border: 1px solid #ddd;
            height: 130px;
            padding: 12px 24px;
            &:hover {
                box-shadow: 2px 2px 10px #eee;
            }
            .titleCont {
                display: flex;
                .title {
                    font-size: 14px;
                    line-height: 2;
                    color: $color-text-primary;
                }
                .icon {
                    font-size: 14px;
                    line-height: 2;
                    margin-left: 4px;
                }
            }

            .num {
                width: 100%;
                font-size: 28px;
                margin-top: 24px;
                text-align: left;
                &:hover {
                    color: $color-primary;
                    cursor: pointer;
                    text-decoration: underline;
                }
            }
        }
        .cardCont_item + .cardCont_item {
            margin-left: 10px;
        }
    }
    .newGoodsCont {
        margin-top: 12px;
        width: 100%;
        display: flex;
        padding-bottom: 12px;
        border-bottom: 1px solid #ddd;
        .newGoodsItemCont + .newGoodsItemCont,
        .newGoodsTotalCont + .newGoodsTotalCont {
            margin-left: 10px;
        }
        .newGoodsTotalCont {
            height: 130px;
            padding: 12px 24px;
            border-right: 1px solid #ddd;
            .title {
                font-size: 14px;
                font-weight: bolder;
                line-height: 2;
                color: $color-text-primary;
                text-align: left;
            }
            .num {
                width: 100%;
                font-size: 28px;
                margin-top: 24px;
                display: flex;
                &:hover {
                    color: $color-primary;
                    cursor: pointer;
                    text-decoration: underline;
                }
            }
        }
        .newGoodsItemCont {
            display: flex;
            justify-content: space-around;
            .newGoodsItem {
                height: 130px;
                box-sizing: border-box;
                padding: 18px 12px 12px 12px;
                .title {
                    font-size: 12px;
                    line-height: 2;
                    color: $color-text-primary;
                }
                .num {
                    width: 100%;
                    font-size: 24px;
                    margin-top: 12px;
                    &:hover {
                        color: $color-primary;
                        cursor: pointer;
                        text-decoration: underline;
                    }
                }
                .tag {
                    margin-top: 12px;
                }
            }
        }
    }
    .chartsCont {
        width: 100%;
        box-sizing: border-box;
        display: flex;
        margin-top: 12px;
    }
}
.auth-tip {
    .el-dialog__body {
        padding: 30px 20px !important;
    }
    .el-dialog__footer {
        margin-bottom: 20px;
    }
    &-body {
        .el-alert {
            padding: 20px;
            background-color: #effef2;
            margin-bottom: 20px;

            .el-alert__title {
                font-size: 14px;
                line-height: 1.7;
                color: #424347;
                word-break: break-word;
            }
        }

        &-store {
            font-size: 20px;
            text-align: center;
            color: #635cff;

            img {
                width: 120px;
            }
        }
    }
}
.tabs{
    margin-top:-10px;
    min-height: 700px;
    .goback{
        position:absolute;
        right:40px;
        top:50px;
        z-index: 999;
    }
    .el-tabs--card>.el-tabs__header .el-tabs__nav{
        border-top: 1px solid #E4E7ED;
    }
    .el-input{
        margin-bottom:10px;
    }
    .el-input__inner{
        border-radius:5px;
        border: 1px solid #E4E7ED
    }
    .listing_cate{
        // display: block;
        margin-top: 8px;
        padding-bottom:18px;
        //padding-top:8px;
        .platform{
            padding:3px 5px;
            cursor: pointer;
            margin-right: 10px;
            border: 1px solid #E4E7ED;
            &:hover{
                border-color: #635cff;
            }
        }
        .visited{
            border: 1px solid #635cff;
        }
        
    }
}

</style>
